export default "__VITE_ASSET__5e46ea50__"